export const PORTAL_BUILDER_PATH = "../portal-builder";
export const CREATE_GUIDANCE_PATH = "../customer-portal/guidance";
export const MANAGE_BUNDLES_PATH = "../customer-portal/bundles";

/** Redo-only exchange agent pages, as settings sub-routes. */
export const PRODUCTS_AS_VARIANTS_PATH = "returns/products-as-variants";
export const VARIANT_EXCHANGE_GUIDANCE_PATH =
  "returns/variant-exchange-guidance";
export const PRODUCT_EXCHANGE_GUIDANCE_PATH =
  "returns/product-exchange-guidance";
